/**
 * Returns the correct slug for a give contentful content type
 */
const cardLinkType = (type) => {
    switch(type) {
        case "ContentfulBlog": return "/blog/";
        case "ContentfulProduct": return "/products/";
        case "ContentfulCaseStudies": return "/case-studies/";
        case "ContentfulArticle": return "/articles/";
        case "ContentfulTraining": return "/training/";
        default: return "";
    }
}

export default cardLinkType;